import { exports as C, __module as M } from "../../../_virtual/YouTubePlayer.mjs";
import "../../debug/src/browser.mjs";
import "./FunctionStateMap.mjs";
import "./eventNames.mjs";
import "./functionNames.mjs";
import { exports as T } from "../../../_virtual/browser.mjs";
import { exports as A } from "../../../_virtual/FunctionStateMap.mjs";
import { exports as F } from "../../../_virtual/eventNames.mjs";
import { exports as L } from "../../../_virtual/functionNames.mjs";
(function(d, i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  var S = T, _ = s(S), g = A, m = s(g), y = F, b = s(y), x = L, E = s(x);
  function s(t) {
    return t && t.__esModule ? t : { default: t };
  }
  const h = (0, _.default)("youtube-player"), c = {};
  c.proxyEvents = (t) => {
    const u = {};
    for (const a of b.default) {
      const r = "on" + a.slice(0, 1).toUpperCase() + a.slice(1);
      u[r] = (o) => {
        h('event "%s"', r, o), t.trigger(a, o);
      };
    }
    return u;
  }, c.promisifyPlayer = (t, u = !1) => {
    const a = {};
    for (const r of E.default)
      u && m.default[r] ? a[r] = (...o) => t.then((e) => {
        const n = m.default[r], N = e.getPlayerState(), p = e[r].apply(e, o);
        return n.stateChangeRequired || // eslint-disable-next-line no-extra-parens
        Array.isArray(n.acceptableStates) && !n.acceptableStates.includes(N) ? new Promise((l) => {
          const f = () => {
            const P = e.getPlayerState();
            let v;
            typeof n.timeout == "number" && (v = setTimeout(() => {
              e.removeEventListener("onStateChange", f), l();
            }, n.timeout)), Array.isArray(n.acceptableStates) && n.acceptableStates.includes(P) && (e.removeEventListener("onStateChange", f), clearTimeout(v), l());
          };
          e.addEventListener("onStateChange", f);
        }).then(() => p) : p;
      }) : a[r] = (...o) => t.then((e) => e[r].apply(e, o));
    return a;
  }, i.default = c, d.exports = i.default;
})(M, C);
//# sourceMappingURL=YouTubePlayer.mjs.map
